module.exports = __webpack_public_path__ + "r-v3/img/ml_22_00_over.3d4fe630.jpg";